module.exports = __webpack_public_path__ + "static/grant-headshot-979b726c77068ef7c60b2184b95dfa9f.jpg";